import { sessionGeneration } from './session';

const cache = new Map(), pending = new Map(), epochs = new Map();
const TTL = 30000;
let resetEpoch = 0;
const epoch = key => `${resetEpoch}:${epochs.get(key) || 0}`;
export async function cachedAPI(key, fetcher, options = {}) {
  const entry = cache.get(key);
  if (!options.force && entry && Date.now() - entry.at < (options.ttl ?? TTL)) return entry.data;
  if (!options.force && pending.has(key)) return pending.get(key);
  const generation = sessionGeneration(), stamp = epoch(key);
  const request = Promise.resolve().then(fetcher).then(data => {
    if (generation !== sessionGeneration() || stamp !== epoch(key)) {
      const error = new Error('This request was superseded. Refresh to see current data.'); error.name = 'CanceledError'; throw error;
    }
    cache.set(key, { data, at: Date.now() }); return data;
  }).finally(() => { if (pending.get(key) === request) pending.delete(key); });
  pending.set(key, request); return request;
}
export const refreshCache = (key, fetcher) => cachedAPI(key, fetcher, { force: true });
export function invalidateCache(keys) {
  for (const key of Array.isArray(keys) ? keys : [keys]) {
    for (const existing of new Set([...cache.keys(), ...pending.keys(), key])) {
      if (existing === key || existing.startsWith(`${key}:`)) {
        cache.delete(existing); pending.delete(existing); epochs.set(existing, (epochs.get(existing) || 0) + 1);
      }
    }
  }
  window.dispatchEvent(new Event('assetflow:data-changed'));
}
export function clearCache() { resetEpoch += 1; cache.clear(); pending.clear(); epochs.clear(); }
export const isCached = key => cache.has(key);
window.addEventListener('assetflow:session-changed', clearCache);
export function invalidateMutation(url = '') {
  if (/\/api\/(auth|pulse)\//.test(url) || /\/(preview|reveal|export)$/.test(url)) return;
  clearCache();
  window.dispatchEvent(new CustomEvent('assetflow:data-changed', { detail: { url } }));
}
